import { useEffect } from 'react';
import { StatusBar } from '@capacitor/status-bar';

const StatusBarHandler = () => {
  useEffect(() => {
    const initializeStatusBar = async () => {
      try {
        // Set status bar style to dark (for light theme)
        await StatusBar.setStyle({ style: 'dark' });
        
        // Set status bar background color to white
        await StatusBar.setBackgroundColor({ color: '#ffffff' });
        
        // Ensure status bar doesn't overlay the webview
        await StatusBar.setOverlaysWebView({ overlay: false });
        
        // Show the status bar
        await StatusBar.show();
        
        console.log('Status bar configured for light theme');
      } catch (error) {
        console.log('Status bar configuration failed (likely running in browser):', error);
      }
    };

    initializeStatusBar();
  }, []);

  return null; // This component doesn't render anything
};

export default StatusBarHandler; 